import Tablesaw from 'tablesaw/dist/stackonly/tablesaw.stackonly';

// Init Tablesaw
Tablesaw.init();
